import Vue from "vue";
import Vuex from "vuex";
import unit from "@/assets/js/common";
import Case from "./modules/caselist.js";
import Users from "./modules/userlist.js";
import Dictionary from "./modules/dictionary"; //字典
import Debinfo from "./modules/debInfo";
import Stages from "./modules/stages"; //分期弹窗操作
import Home from "./modules/home"; //首页
import getters from "./getters";
import DisForm from "./modules/disForm";
import setWatermark from "@/assets/js/watermark.js";
import FileManage from "../components/FileManage/index.vue";
Vue.use(Vuex);
const state = {
  watermarks: {
    bg1: null,
    bg2: null,
  },
  user: localStorage.getItem("t")
    ? localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {}
    : {},
  StepLite: null,
  updateTime: null, //进度更新时间
  StepKey: null, //訴訟進度權限key
  editJA: false, //结案
  dislog: {
    filelist: false, //基本信息附件
    FileHistory: false, //保全记录
    call: false, //催收记录
    Other: false, //关联被告信息
    Laysuit: false, //案件
    His: false, //沟通记录
    stepbox: false, //案件列表
    stepboxorder: false, //插入进度
    agentbox: false, //代理人弹窗
    beforetime: false, //卷宗移交时间
    beforestart: false, //卷宗移交时间
    police: false,
    ones: false, //一审立案      二审立案
    preservation: false, //诉前保全
    twos: false, //一审 诉调
    three: false, //一审立案
    Fours: false, //一审待开庭
    Five: false,
    Six: false,
    Twelve: false, //再审
    Car: false, //车辆信息
    Fiveteen: false,
    reason: false, //作废原因
    Book: false,
    OtherType: false,
    CauseStepLog: false, //操作记录
    partyPopUp: false, //当事人信息修改或添加
    CasePopUp: false, //案件信息修改或添加
    Compensation: false, //本案代偿明细,
    globalModal: false, //全局管理
    paymentPopUp: false, //诉讼相关费用缴费明细
    share: false, //反馈列表
    filemanage: false,
    chat: false,
    fileEditing: false,
    editFileURL: "", //预览文件url
    PopUpFileInformation: false,
  },
  Edit: false, //
  nineBool: false, //二审待开庭 是原告 还是被告
  cause: {}, //当前案件
  chatUnreadCount: 0, //聊天总未读,
};
export default new Vuex.Store({
  strict: true,
  state,
  getters,
  mutations: {
    SET_WATERMARKS(state, { bg1, bg2 }) {
      //设置背景水印
      state.watermarks.bg1 = bg1;
      state.watermarks.bg2 = bg2;
      // 存储到 localStorage
      localStorage.setItem("watermark_bg1", bg1);
      localStorage.setItem("watermark_bg2", bg2);
    },
    INIT_WATERMARKS(state) {
      const bg1 = localStorage.getItem("watermark_bg1");
      const bg2 = localStorage.getItem("watermark_bg2");
      if (bg1 && bg2) {
        state.watermarks.bg1 = bg1;
        state.watermarks.bg2 = bg2;
      }
    },
    //设置首页数字
    SETTIME(state, value) {
      //进度更新时间
      state.updateTime = value;
    },
    SETUser(state, value) {
      //用户 登录状态
      state.user = value;
    },
    SETKEY: (state, value) => {
      //设置key
      state[value.key] = value.value;
    },
    REMOVEKEY: (state, value) => {
      //删除key
      state[value] = null;
    },
    OPENKEY: (state, value) => {
      //弹窗开关
      state.dislog[value.key] = value.by;
    },
    // 获取预览url文件
    SET_EDIT_FILE_URL: (state, url) => {
      state.dislog.editFileURL = url;
    },
    SET_CHAT_UNREAD(state, val) {
      state.chatUnreadCount = val;
    },
  },
  actions: {
    settime({ commit }, value) {
      commit("SETTIME", value);
    },
    setuser({ commit }, value) {
      commit("SETUser", value);
    },
    setkey({ commit }, value) {
      commit("SETKEY", value);
    },
    removekey({ commit }, value) {
      commit("REMOVEKEY", value);
    },
    openkey({ commit }, value) {
      commit("OPENKEY", value);
    },
    setEditFileURL({ commit }, url) {
      commit("SET_EDIT_FILE_URL", url);
    },
    updateWatermarks({ commit, state }) {
      const bg1 = state.user.uname
        ? setWatermark(
            state.user.uname,
            state.user.phone || "",
            1,
            state.user.login_location,
          )
        : "";
      const bg2 = state.user.uname
        ? setWatermark(
            state.user.uname,
            state.user.phone || "",
            2,
            state.user.login_location,
          )
        : "";
      commit("SET_WATERMARKS", { bg1, bg2 });
    },
    loadWatermarks({ commit }) {
      commit("INIT_WATERMARKS");
    },
  },
  modules: {
    Case,
    Users,
    Home,
    Dictionary,
    Debinfo,
    DisForm,
    Stages,
  },
});
